// extracted by mini-css-extract-plugin
export default {"intro":"Home_intro__XcP8m","email":"Home_email__yazMU","image":"Home_image__i0UYf"};